export default __webpack_public_path__ + "static/quantstamp-9498cabf6d334571fdcf3e4a67b288e5.png";